import { useEffect } from "react";
import AllRoute from '../router'
import '../../sass/style.scss';
import useSplitTextAnimation from '../../components/splittextAnimation/useSplitTextAnimation';
import "animate.css";
import Lenis from "lenis";

const App = () => {
  useSplitTextAnimation();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      smoothWheel: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }, []);

  return (
    <div className="App lenis" id='scrool'>
      <AllRoute />
    </div>
  );
}

export default App;
